import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// material-ui
import { 
    Button, DialogContent, Dialog, DialogActions, 
    Typography, Box, Stack, Alert 
} from '@mui/material'
import { WarningOutlined } from '@ant-design/icons'

// third party
import { useSnackbar } from "notistack";

// project import
import { useEventBusContext } from 'services/provider/EventBusProvider'
import { categoryDelete } from 'models/category';
import { EVENT_CATEGORY_DELETE_INIT, EVENT_CATEGORY_UPDATE_SUCCESS } from 'models/events/category.event';

/*
 * Initiate category delete dialog.
 */
export const CategoryDeleteDialog = () => {
    const eventbus = useEventBusContext()
    const [categorydelete, setCategoryDelete] = useState(null)

    useEffect(() => {
        return eventbus.on(EVENT_CATEGORY_DELETE_INIT, (id) => {
            setCategoryDelete(id)
        })
    }, [eventbus])

    return (
        <Dialog 
            open={categorydelete != null} 
            scroll={'body'} 
            maxWidth="sm" 
            fullWidth={true} 
            onClose={() => setCategoryDelete(null)} 
        >
            {categorydelete && <CategoryDelete 
                categorydelete={categorydelete} 
                onClose={() => setCategoryDelete(null)} 
                onSuccess={(data) => {
                    eventbus.fire(EVENT_CATEGORY_UPDATE_SUCCESS, data)
                    setCategoryDelete(null)
                }} 
            />}
        </Dialog>
    )
}

/**
 * Sample delete dialog. 
 */
const CategoryDelete = ({ categorydelete, onClose, onSuccess }) => {
    const category = categorydelete;
    const { enqueueSnackbar } = useSnackbar();
    const [isDeleting, setIsDeleting] = useState(false);

    const onSubmit = async () => {
        setIsDeleting(true);
        await categoryDelete(category.id || category)
            .then((res) => {
                onSuccess(res.data)
                enqueueSnackbar(res.message || 'Category deleted successfully', { 
                    variant: 'success', 
                    autoHideDuration: 2000 
                })
            })
            .catch((res) => {
                enqueueSnackbar(res.message || 'Failed to delete category', { 
                    variant: 'error', 
                    autoHideDuration: 2000 
                })
                setIsDeleting(false);
            })
    }

    return (
        <Box>
            <DialogContent dividers sx={{ px: 4, py: 4 }}>
                <Typography variant="h5" sx={{ pr: 2 }} >Are you sure you want to delete {category?.name ? category.name : 'this category'}?</Typography>
            </DialogContent>
            <DialogActions sx={{ p: 1.5 }}>
                <Button onClick={onClose} type="button" variant="outlined" color="error">Cancel</Button>
                <Button type="submit" variant="contained" color="error" onClick={onSubmit} disabled={isDeleting}>
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Box>
    )
}


//CategoryDelete component prop type declaration
CategoryDelete.propTypes = {
    categorydelete: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default CategoryDelete

